/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Create_ConsentInputs */

const fr_guardian_create_consent = /** @type {(inputs: Guardian_Create_ConsentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le consentement parental a été recueilli`)
};

/**

* @param {Guardian_Create_ConsentInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_create_consent = /** @type {((inputs?: Guardian_Create_ConsentInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Create_ConsentInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_create_consent(inputs)
});